import React, { Suspense, useContext, useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import { useDeleteData, useFetchData } from "hooks/useApiHooks";
import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";

// Metric Card Component (updated for booking data)
const MetricCard = ({ title, value, currency }) => {
  return (
    <table className="table">
      <tbody>
        <tr>
          <td className="text-muted ">{title}</td>
          <td className=" text-end">
            {currency ? `IDR ${value.toLocaleString()}` : value}
          </td>
        </tr>
      </tbody>
    </table>
    // <div className="row">
    //   <div className="col-12">
    //     <div className="py-2 d-flex justify-content-between">
    //       {/* Title */}
    //       <div className="text-muted fs-1">{title}</div>
    //       <div className="fs-1">
    //         {currency ? `IDR ${value.toLocaleString()}` : value}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

// Report Card Component for booking summary
const ReportCard = () => {
  const reportData = [
    {
      title: "Total Jumlah Order Produk",
      value: 1897,
      currency: false,
    },
    {
      title: "Total Order",
      value: 888270000,
      currency: true,
    },
    {
      title: "Total Pembayaran",
      value: 446285000,
      currency: true,
    },
    {
      title: "Total Sisa Pembayaran",
      value: 441985000,
      currency: true,
    },
    {
      title: "Total Komisi Agen",
      value: 154270000,
      currency: true,
    },
    {
      title: "Total Order Setelah Komisi Agen",
      value: 734000000,
      currency: true,
    },
  ];

  return (
    <div className="row justify-content-center mb-3">
      <div className="col-12 mb-3">
        <div
          className="shadow-sm card-metric card d-flex flex-column p-0"
          style={{
            borderRadius: "10px",
            border: "none",
            height: "100%", // Ensure the card takes full height of the container
          }}
        >
          {/* table header */}
          <div className="card-header ">
            <h2 className="m-0">Total Data</h2>
          </div>
          
          {reportData.map((data, index) => (
            <MetricCard
              key={index}
              title={data.title}
              value={data.value}
              currency={data.currency}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// Table Component for displaying booking details
const BookingTable = ({ bookings, handleDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table table-hover table-vcenter">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Pelanggan</th>
            <th>Jumlah Tamu</th>
            <th>Nama Agen</th>
            <th>Tanggal Pemesanan</th>
            <th>Sesi</th>
            <th>Total Penjualan</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking, index) => (
            <tr key={index}>
              <td>{booking.orderNumber}</td>
              <td>{booking.customerName}</td>
              <td>{booking.guestCount}</td>
              <td>{booking.agentName}</td>
              <td>{booking.orderDate}</td>
              <td>{booking.session}</td>
              <td>IDR {booking.totalSales.toLocaleString()}</td>
              <td>{booking.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Main Page Component for Booking Report
const LaporanBooking = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const queryString = buildQueryString({
    search: search || "",
    page: currentPage,
    limit: LIMIT_DATA_PER_PAGE,
  });

  useFetchData(`/bookings${queryString}`, "bookings");
  const { deleteData } = useDeleteData("/bookings", "bookings", queryString);

  const { state } = useContext(AppContext);

  // Example booking data
  const bookings = [
    {
      orderNumber: "24120010",
      customerName: "Komang Gede",
      guestCount: 5,
      agentName: "Tobi",
      orderDate: "2024-12-13",
      session: "Sesi 5",
      totalSales: 1000000,
      status: "Completed",
    },
    {
      orderNumber: "24120009",
      customerName: "Komang Gede",
      guestCount: 3,
      agentName: "Tobi",
      orderDate: "2024-12-13",
      session: "Sesi 5",
      totalSales: 500000,
      status: "Pending",
    },
  ];

  const handleDelete = (e, id) => {
    e.stopPropagation();
    deleteData(id);
  };

  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const totalPages = bookings.length > 0 ? 1 : 0;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  if (bookings.loading) return <FullLoader />;
  if (bookings.error) return <Suspense error={bookings.error} />;

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
      <h1>Laporan Booking</h1>

        {/* Report Card for Booking Summary */}
        <ReportCard />

        {/* Search Button */}
        <div className="table-container vh-100">
          <div className="search-container mb-3">
            {/* <SearchInput handleSearch={handleSearch} defaultValue={search} /> */}
          </div>

          {/* Bookings Table */}
          <BookingTable bookings={bookings} handleDelete={handleDelete} />

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default LaporanBooking;
